import React from 'react'
import Header from '../components/Header'
import { Footer } from '../components/Footer'
import CreateAccountPage from '../views/createAccount/createAccountPage'

const CreateAccount = () => {
  window.scrollTo(0, 0);

  return (
    <>
      <Header />
      <CreateAccountPage />
      <Footer />
    </>
  )
}

export default CreateAccount
